import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../../../services';


@Injectable()
export class PartyProfilerService {
  private http = inject(HttpClient);
  private _appService = inject(AppService);


  private headers = new HttpHeaders();
  private partyprofile = this._appService.getServerBaseUrl + '/partyprofiler';
  private suiteUrl = this._appService.getServerBaseUrl + '/suite';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.headers.append("Accept", "*/*")
    this.headers.append("Content-Type", "application/json")
  }

  getPartProfiler(companyId: any): Observable<any> {
    const url = `${this.partyprofile}/expiringcompetence?companyId=${companyId}`;
    let options = { headers: this.headers, withCredentials: true };

    return this.http.get(url, options)

  }

  getUserCompanies(): Observable<any> {

    let options = { headers: this.headers, withCredentials: true };

    return this.http.get(this.suiteUrl, options)
  }
}
